(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    const contactFormSuccess = document.querySelector('.contact-form__success');

  if (contactFormSuccess) {
    requestAnimationFrame(() => {
      contactFormSuccess.focus({ preventScroll: true });
      contactFormSuccess.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        block: 'center',
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
